import React from "react";
import { Helmet } from "react-helmet-async";
import { Container } from "react-bootstrap";
import useBots from "../../../hooks/useBots";
import QDLoader from "../../../components/QDLoader";
import Testing from "../../../components/bots/Testing";
import Header from "./Header";
import { useTranslation } from "../../../hooks/useLocalization";

const TestingPage = () => {
  const { t } = useTranslation();
  const { isInitialized } = useBots();
  return (
    <React.Fragment>
      <Helmet title={t("Testing")} />
      <Container fluid className="p-0">
        <Header />
        {isInitialized ? <Testing /> : <QDLoader />}
      </Container>
    </React.Fragment>
  );
};

export default TestingPage;
